// Literal class per column count so Tailwind's JIT sees every one of them.
const XL_COLS = {
  2: "xl:grid-cols-2",
  3: "xl:grid-cols-3",
  4: "xl:grid-cols-4",
  5: "xl:grid-cols-5",
};

/**
 * A row of dashboard stat tiles: stacked on phones, two-up on tablets and the
 * full `cols` row from xl, where the dashboards used to force a 1350px width.
 */
const StatGrid = ({ cols, children }) => (
  <div className={`grid grid-cols-1 gap-4 sm:grid-cols-2 ${XL_COLS[cols]}`}>
    {children}
  </div>
);

export default StatGrid;
